/*
 * @Author: DQL
 * @Date: 2020-06-03 14:32:08
 * @LastEditors: DQL
 * @LastEditTime: 2022-01-28 17:07:28
 * @Description: file content
 */
/*
 * @Author: SZM
 * @Date: 2020-03-26 18:27:28
 * @LastEditors: DQL
 * @LastEditTime: 2020-06-03 14:23:59
 // eslint-disable-next-line no-irregular-whitespace
 * @Description: content
 */
import axios from 'axios';
import config from '@/config';

const { workflowCtx, kqxtApi } = config.ctx;

export const getDeptTree = (processInsId, workItemId, params) => { return axios.get(`${workflowCtx}/workflow/getWorkflowSwjgList/${processInsId}/${workItemId}`, { params }); };

export const getGwList = (processInsId, workItemId, params) => { return axios.get(`${workflowCtx}/workflow/getWorkflowGwList/${processInsId}/${workItemId}`, { params }); };

export const getUserList = (processInsId, workItemId, params) => { return axios.get(`${workflowCtx}/workflow/getWorkflowSwryList/${processInsId}/${workItemId}`, { params }); };

export const completeSelect = (processInsId, workItemId, fd) => { return axios.post(`${workflowCtx}/workflow/complete/${processInsId}/${workItemId}`, fd); };

export const selectUserService = {

  // 获取组织机构 /kqxt/workflow/getWorkflowBmList/{processInsId}/{taskId}
  getDeptTree: (processInsId, workItemId, params) => { return axios.get(`${kqxtApi}/kqxt/workflow/getWorkflowBmList/${processInsId}/${workItemId}`, { params }); },

  // 获取岗位 /kqxt/workflow/getWorkflowGwList/{processInsId}/{taskId}
  getGwList: (processInsId, workItemId, params) => { return axios.get(`${kqxtApi}/kqxt/workflow/getWorkflowGwList/${processInsId}/${workItemId}`, { params }); },

  // 获取办理人 /kqxt/workflow/getWorkflowSwryList/{processInsId}/{taskId}
  getUserList: (processInsId, workItemId, params) => { return axios.get(`${kqxtApi}/kqxt/workflow/getWorkflowSwryList/${processInsId}/${workItemId}`, { params }); }

};
